import { connect } from 'react-redux'

import PromoCodeForm from './PromoCodeForm'
import { redeemPromoCode, isRedeemingPromoCode, getPromoCode } from '@src/redux/modules/service'

const select = (state) => {
  return {
    redeeming: isRedeemingPromoCode(state),
    promoCode: getPromoCode(state)
  }
}

const actions = {
  redeem: redeemPromoCode
}

export default connect(select, actions)(PromoCodeForm)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/SecondTimeBookingConfirmation/components/PromoCodeForm/PromoCodeFormContainer.js